<template>
    <div>
        <a-form :form="form" style=" margin:30px 10px 10px 10px;">
            <a-form-item
                  v-if="false"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="试听音乐"
                  hasFeedback
              > 
                <file-uploader
                    :numberLimit="100"
                    accept=".mp3,.wma"
                    :file-list="formData.music"
                /> 
              </a-form-item>
            <a-form-item
                    label="内容详情"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
            >
                <a-radio-group v-model="contentLang" style="margin-bottom: 12px;">
                    <a-radio-button value="zh">中文</a-radio-button>
                    <a-radio-button value="en">English</a-radio-button>
                </a-radio-group>
                <UEditor
                    v-if="contentLang === 'zh'"
                    :key="'content-zh-' + formData.id"
                    style="width: 800px; height:520px;"
                    :ueditorContent.sync="formData.content"
                />
                <UEditor
                    v-else
                    :key="'content-en-' + formData.id"
                    style="width: 800px; height:520px;"
                    :ueditorContent.sync="formData.content_en"
                />
            </a-form-item>

            <a-affix :offsetBottom="0">
                <div style="background: #fff; padding: 10px 0 20px 0 ; border-top: 1px solid #eee  ">
                    <a-button style="margin-right: 10px;" @click="prevStep">上一步</a-button>
                    <a-button type="primary" :loading="saveLoading" @click="submitForm">保存</a-button>
                </div>
            </a-affix>
        </a-form>
    </div>
</template>

<script>
    import UEditor from '@/components/UEditor/'
  import FileUploader from '@/components/FileUploader/'

    import {getGoodsDetail, goodsContentEdit} from '@/api/goods'

    export default {
        name: 'Step3',
        components: {
            UEditor,
            FileUploader,
        },
        props: {
            goodsId: null,
            currentTab: null,
        },
        data() {
            return {
                saveLoading: false,
                labelCol: {
                    xs: {span: 24},
                    sm: {span: 5},
                },
                wrapperCol: {
                    xs: {span: 24},
                    sm: {span: 16},
                },
                form: this.$form.createForm(this),
                contentLang: 'zh',
                formData: {
                    id: 0,
                    music:[],
                    content: '',
                    content_en: ''
                }
            }
        },
        watch: {
            currentTab(newVal) {
                console.log('currentTab');
                console.log(newVal);
                if (newVal == 2) {
                    let that = this;
                    that.formData.id = that.goodsId;
                    that.fetch();
                }
            }
        },
        methods: {
            fetch() {
                let that = this;
                getGoodsDetail({
                    id: that.goodsId
                }).then(res => {
                    that.formData = res.data;
                    if (!that.formData.content_en) {
                        that.$set(that.formData, 'content_en', '');
                    }
                }).catch(err => {
                    that.$message.error(err.data.msg);
                })
            },
            submitForm(e) {
                let self = this
                e.preventDefault()
                self.form.validateFields((err, values) => {
                    if (!err) {
                        self.saveLoading = true;
                        console.log('Received values of form: ', values)
                        console.log('Received valuess of formData: ', self.formData)
                        self.saveLoading = true;
                        goodsContentEdit({
                            id: self.goodsId,
                            content: self.formData.content,
                            content_en: self.formData.content_en || '',
                            music: self.formData.music,
                        }).then(res => {
                            self.$message.success('保存成功')
                            self.saveLoading = false;

                            self.$router.push({
                                name: "GoodsList"
                            })
                        }).catch(err => {
                            self.$message.error(err.data.msg);
                            self.saveLoading = false;
                        })
                    } else {
                        console.log(err);
                    }
                })
            },
            prevStep() {
                this.$emit('prevStep')
            },
            toOrderList() {
            }
        }
    }
</script>
<style lang="less" scoped>
    .information {
        line-height: 22px;

        .ant-row:not(:last-child) {
            margin-bottom: 24px;
        }
    }

    .money {
        font-family: "Helvetica Neue", sans-serif;
        font-weight: 500;
        font-size: 20px;
        line-height: 14px;
    }
</style>